import { FC } from 'react';
import { Button } from 'antd';
import Select, { DefaultOptionType, SelectProps } from 'antd/lib/select';
import { CustomSensorModel } from 'components/pages/AssetPage/Tabs/TabConsumption/OptionList/resources/models';
import './styles.scss';

interface TagsListSelectorProps {
  sensor: CustomSensorModel;
  placeholder: string;
  saveButtonText: string;
  cancelButtonText: string;
  selectedTags: string[];
  availableTags: DefaultOptionType[];
  selectMode?: SelectProps['mode'];
  onSaveTags: (sensor: CustomSensorModel, newTags: string[]) => void;
  onChangeTags: (values: string[] | null) => void;
  onCloseTags: () => void;
  onFilterTags: (input: string, option?: DefaultOptionType) => boolean;
  isSavingTagsList: boolean;
  allowClear?: boolean;
}

const TagsListSelector: FC<TagsListSelectorProps> = ({
  sensor,
  placeholder,
  selectedTags,
  saveButtonText,
  cancelButtonText,
  availableTags,
  selectMode,
  onSaveTags,
  onChangeTags,
  onCloseTags,
  onFilterTags,
  isSavingTagsList,
  allowClear
}) => (
  <div className={'TagsListSelector__wrapper'}>
    <Select
      value={selectedTags}
      mode={selectMode}
      options={availableTags}
      placeholder={placeholder}
      onChange={onChangeTags}
      filterOption={onFilterTags}
      allowClear={allowClear}
      autoFocus
      showArrow
      defaultOpen
    />
    <div className={'TagsListSelector__wrapper-buttons'}>
      <Button
        type={'link'}
        className={'TagsListSelector__button'}
        onClick={() => onSaveTags(sensor, selectedTags)}
        loading={isSavingTagsList}
      >
        {saveButtonText}
      </Button>
      <Button
        type={'text'}
        className={'TagsListSelector__button'}
        onClick={onCloseTags}
        disabled={isSavingTagsList}
      >
        {cancelButtonText}
      </Button>
    </div>
  </div>
);

export default TagsListSelector;